import React, { Component, useDebugValue } from 'react';
import { Link } from 'react-router';
import { Row, Col } from 'reactstrap';
// import { FieldCol, FieldGroup, FieldLabel, FieldInput, FieldSelect, FieldTextarea, FieldDate} from '../../Elements';
import { leaseTypeDrpdwn } from '../../../../constants';
import {checkString} from '../../../../formValidator'
import { jetStreamInstance } from '../../../Leases';
import { FieldCol, FieldGroup, FieldInput, FieldLabel, FieldSelect, FieldTextarea} from '../../../../applications/contracts/Elements';
import { avationPlcInstance, leshaBankInstance, mtInstance } from '../../../../shared_elements/components';
export default class EditSubleaseCard extends Component{
  constructor(props){
    super(props);
    this.state = {
      subleasecard: {},
      error: {}
    }
  }
  componentDidMount(){
    this.updateHdState(this.props.subleasecard);
  }
  updateHdState = (subleasecard) => {
    let data = Object.assign({}, subleasecard);
    this.setState({
        subleasecard: data
    });
  }
  updateForm = (type, value) => {
    if(['sublease_fee','right_sublease_without_approval','sublease_comment'].includes(type)){
      this.setState(prevState => ({
        subleasecard: {
          ...prevState.subleasecard,
          titan_extra_fields: {
            ...prevState.subleasecard?.titan_extra_fields,
            [type]: value,
          },
        },
      }));
    }
  }
  updateWetLeaseCard = (e) => {
    e.preventDefault();
    const titan_extra_fields = { ...this.state.subleasecard.titan_extra_fields };
    this.props.updateWetLeaseCard({ titan_extra_fields });
  }
  render(){
    const { type, portfolioList, ownerList } = this.props;
    const { error, subleasecard } = this.state;
      return(
        <form onSubmit={(e) => this.updateWetLeaseCard(e)}>
          <div style={{ height: (window.innerHeight - 157) + 'px', overflow:'auto',marginBottom:'60px' }}>
          <Row>
              <FieldCol md="12">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">Right to Sub Lease without prior Approval</FieldLabel>
                    <FieldSelect
                      placeholder='Select YES/NO'
                      keyParam="right_sublease_without_approval"
                      value={subleasecard?.titan_extra_fields?.right_sublease_without_approval || ''}
                      type={type}
                      options={[{ label: 'YES', value: 'YES' },{ label: 'NO', value: 'NO' }]}
                      updateField={this.updateForm}
                      labelKey='label'
                      valueKey='value'
                    />
                </FieldGroup>
              </FieldCol>
            </Row>
            <Row>
              <FieldCol md="12">
                  <FieldGroup className="form-group">
                    <FieldLabel className="label">Sub Lease Fee</FieldLabel>
                    <FieldSelect
                      placeholder='Select YES/NO'
                      keyParam="sublease_fee"
                      value={subleasecard?.titan_extra_fields?.sublease_fee || ''}
                      type={type}
                      options={[{ label: 'YES', value: 'YES' },{ label: 'NO', value: 'NO' }]}
                      updateField={this.updateForm}
                      labelKey='label'
                      valueKey='value'
                    />
                </FieldGroup>
              </FieldCol>
            </Row>
            {(mtInstance || avationPlcInstance || leshaBankInstance) ?
            <Row>
              <FieldCol md="12">
                <FieldGroup className="form-group">
                  <FieldLabel className="label">Sub Lease Comment</FieldLabel>
                  <FieldTextarea
                    value={subleasecard?.titan_extra_fields?.sublease_comment || ''}
                    type={type}
                    keyParam="sublease_comment"
                    updateField={this.updateForm}
                  />
                </FieldGroup>
              </FieldCol>
            </Row>:null}
         </div>
         <div className="submit-block">
           <input type="submit" className="primary-btn" value="Save Changes"/>
           <Link onClick={() => this.props.toggleEditSideBar()} >Cancel</Link>
         </div>
       </form>
      )
  }
}
